(function() {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('passwordCharactersValidator', function() {
      function passwordLen(value) {
        return ('' + (value || '')).length >= 8;
      }

      function passwordUpperChars(value) {
        return /[A-Z]/.test(value);
      }

      function passwordLowerChars(value) {
        return /[a-z]/.test(value);
      }

      function passwordSpecChars(value) {
        return /[^A-Za-z\d]/.test(value);
      }

      function passwordNums(value) {
        return /\d+/.test(value);
      }

      function any(value) {
        return passwordLen(value) &&
          passwordUpperChars(value) &&
          passwordLowerChars(value) &&
          passwordSpecChars(value) &&
          passwordNums(value);
      }

      return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$validators.passwordLen = passwordLen;
          ngModel.$validators.passwordUpperChars = passwordUpperChars;
          ngModel.$validators.passwordLowerChars = passwordLowerChars;
          ngModel.$validators.passwordSpecChars = passwordSpecChars;
          ngModel.$validators.passwordNums = passwordNums;
          ngModel.$validators.any = any;
        }
      }
    })
    .directive('compareToValidator', function() {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function(scope, element, attrs, ngModel) {
          scope.$watch(attrs.compareToValidator, function() {
            ngModel.$validate();
          });

          ngModel.$validators.compareTo = function(value) {
            var other = scope.$eval(attrs.compareToValidator).$viewValue;
            return !value || !other || value === other;
          }
        }
      }
    });
})();
